import {Provider} from 'react-redux';
import {useEffect, Fragment} from 'react';
import {persistStore} from 'redux-persist';
import {PersistGate} from 'redux-persist/integration/react';
import {ToastProvider} from 'react-native-toast-notifications';
import {SafeAreaProvider} from 'extensions/viewport/SafeArea';
import {BottomSheetModalProvider} from 'extensions/viewport/BottomSheetProvider';
import {GestureProvider} from 'extensions/viewport/GestureProvider';
import {ModalProvider} from 'extensions/viewport/ModalProvider';
import {PopupProvider} from 'extensions/viewport/PopupProvider';
import {I18nProvider} from 'extensions/i18n';
import {Navigator} from 'interface/Navigator';
import {Router} from 'extensions/navigation';
import {colors} from 'config/styles';
import store, {history} from 'store';

export function Main() {
  return (
    <Fragment>
      <ToastProvider normalColor={colors.neutral.dark} dangerColor={colors.secondary.darkRed}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistStore(store)}>
            <I18nProvider>
              <SafeAreaProvider>
                <GestureProvider style={{flex: 1}}>
                  <BottomSheetModalProvider>
                    <ModalProvider>
                      <PopupProvider>
                        <Router history={history}>
                          <Navigator/>
                        </Router>
                      </PopupProvider>
                    </ModalProvider>
                  </BottomSheetModalProvider>
                </GestureProvider>
              </SafeAreaProvider>
            </I18nProvider>
          </PersistGate>
        </Provider>
      </ToastProvider>
    </Fragment>
  );
}
